module.exports = __webpack_public_path__ + "img/inktober_2020_29_shoes.de5e65a3.jpg";